<template>
    <b-modal
        id="project-add-course-modal"
        size="md"
        ok-only
        :ok-title="$t('common.close')"
        :title="$t('project.choose_course')"
        modal-class="apprentice-default-modal courses-modal"
        @show="getCourses">
        <design-2021-apprentice-data-table
            v-if="courses.length"
            :fields="courseSelectFields"
            :items="courses">
            <template v-slot:cell(choose)="row">
                <b-button
                    class="btn-add"
                    v-if="showAdd(row.item)"
                    variant="primary-icon-only"
                    @click="checkStudentLink(row.item.id)">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>

        <design-2021-project-add-course-to-whom-modal-component
            @addSpecific="addCourse($event)"
            :common-max-reached-in="maxCommonReached"
            :personal-max-reached-in="maxPersonalReached"
            :project-in="projectIn"
            ref="project-add-course-to-whom-modal">
        </design-2021-project-add-course-to-whom-modal-component>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-project-add-course-modal-component',
    props: ['projectIn', 'currentCoursesIn'],
    data() {
        return {
            project: this.projectIn,
            courses: [],
        };
    },
    computed: {
        courseSelectFields() {
            let courseSelectFields = [
                {
                    key: 'name',
                    label: this.$t('project.course'),
                },
            ];
            if (this.projectIn.group.group_pair_options?.course_student_link && !this.$authUser.isStudent()) {
                courseSelectFields.push({
                    key: 'belongsTo',
                    label: this.$t('project.from'),
                });
            }
            courseSelectFields.push({
                key: 'choose',
                label: this.$t('common.choose'),
            });
            return courseSelectFields;
        },
        maxCommonReached() {
            if (this.project.group.group_pair_options?.course_max) {
                return (
                    this.currentCoursesIn.filter((course) => course.common).length >=
                    this.project.group.group_pair_options.course_max
                );
            }
            return false;
        },
        maxPersonalReached() {
            if (
                this.project.group.group_pair_options?.course_max &&
                this.project.group.group_pair_options?.course_student_link
            ) {
                return (
                    this.currentCoursesIn.filter((course) => course.personalIds.includes(this.$authUser.id)).length >=
                    this.project.group.group_pair_options.course_max
                );
            }
            return false;
        },
    },
    methods: {
        showAdd(course) {
            if (this.$authUser.isStudent()) {
                let canBeAddedCommon = !(this.maxCommonReached || course.common);
                let canBeAddedPersonal = false;
                if (this.project.group.group_pair_options?.course_student_link) {
                    let canBeAddedPersonal = !(
                        this.maxPersonalReached || course.personalIds.includes(this.$authUser.id)
                    );
                }
                return canBeAddedCommon || canBeAddedPersonal;
            }
            return !(
                course.common &&
                !this.projectIn.users.filter((user) => user.type === 'student' && !course.personalIds.includes(user.id))
                    .length
            );
        },

        getCourses() {
            this.axios
                .get(
                    this.routes.paperCoursesGet(this.projectIn.id) +
                        '?query=&limit=10000&ascending=1&page=1&byColumn=0',
                )
                .then(
                    (response) => {
                        if (this.projectIn.group.group_pair_options?.course_student_link) {
                            this.courses = response.data.data.map((course) => {
                                if (course.projects.length) {
                                    let projectCourse = this.currentCoursesIn.find(
                                        (course2) => course2.id === course.id,
                                    );
                                    if (projectCourse) {
                                        course.personalIds = projectCourse.personalIds;
                                        course.common = projectCourse.common;
                                    } else {
                                        course.personalIds = [];
                                        course.common = false;
                                    }
                                    let wholeGroup = projectCourse.common ? this.$t('project.the_whole_group') : null;
                                    if (wholeGroup) {
                                        course.belongsTo = wholeGroup + ', ' + projectCourse.personal;
                                    } else {
                                        course.belongsTo = projectCourse.personal;
                                    }
                                } else {
                                    course.personalIds = [];
                                    course.common = false;
                                }
                                return course;
                            });
                        } else {
                            this.courses = response.data.data;
                        }
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
        },
        checkStudentLink(id) {
            if (this.projectIn.group.group_pair_options?.course_student_link) {
                this.$refs['project-add-course-to-whom-modal'].show(this.courses.find((course) => course.id === id));
            } else {
                this.addCourse(id);
            }
        },

        addCourse(dataIn) {
            this.alert.saving();

            let data = {
                course_id: dataIn,
                user_id: null,
            };

            if (typeof dataIn === 'object') {
                data.course_id = dataIn.courseId;
                data.user_id = dataIn.userId;
            }

            this.axios.post(this.routes.paperCourseAdd(this.projectIn.id), data).then(
                (response) => {
                    this.project.courses.push(response.data.course);
                    this.$emit('updateCourses', response.data.course);
                    this.getCourses();
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
